var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMarkUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8473 21.2472C15.9544 21.2472 20.0945 17.1071 20.0945 12C20.0945 6.89291 15.9544 2.7528 10.8473 2.7528C5.74021 2.7528 1.6001 6.89291 1.6001 12C1.6001 17.1071 5.74021 21.2472 10.8473 21.2472Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 3.0784L10.9632 15.3232L5.84644 10.568",
    stroke: "#E2D4F4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkUnchecked);
export default __webpack_public_path__ + "static/media/check-mark-unchecked.979818d79431150e4c0b6d5a0e430a0c.svg";
export { ForwardRef as ReactComponent };